import { ReactNode, useMemo, useState } from 'react';

import { ISelectedNode, SelectedNodeContext } from './SelectedNodeContext';

type Props = {
  children: ReactNode;
};

export const SelectedNodeProvider = ({ children }: Props) => {
  const [selectedNode, setSelectedNode] = useState<ISelectedNode | undefined>(undefined);

  const value = useMemo(() => ({ selectedNode, setSelectedNode }), [selectedNode]);

  return <SelectedNodeContext.Provider value={value}>{children}</SelectedNodeContext.Provider>;
};
